import { extend } from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { ProductQuantity } from '@thd-olt-component-react/quantity';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { Promotion } from '@thd-olt-component-react/promotion';
import {
  ProductPod as ProductPodOlt,
  ProductATC, ProductRating, ProductSample,
  ProductIdentifier, ProductImage, ProductCompare,
  ProductSponsored, ProductBadge,
} from '@thd-olt-component-react/product-pod';

export const ProductPodDataModel = extend(
  ProductPodOlt,
  AddToList,
  FulfillmentPodStore,
  FulfillmentPodShipping,
  KeyProductFeatures,
  Price,
  ProductATC,
  ProductCompare,
  ProductHeader,
  ProductIdentifier,
  ProductImage,
  ProductQuantity,
  ProductRating,
  ProductSample,
  ProductSponsored,
  Promotion,
  ProductBadge,
);
